import { Overline, SectionHeading } from "@/components/Section";
import LeadForm from "@/components/LeadForm";
import { Check } from "lucide-react";

export default function ClientsApply() {
  return (
    <div data-testid="apply-page">
      <section className="section-pad">
        <div className="container-tib grid lg:grid-cols-[1fr_1.1fr] gap-16">
          <div>
            <SectionHeading
              overline="Have TIB build your platform"
              title="Tell us what to build."
              body="Submit a build request and we'll get back to you with next steps. The more detail, the faster we can scope it."
            />
            <ul className="mt-10 space-y-4" data-testid="apply-benefits">
              {[
                "Production full-stack build — not a prototype",
                "PaaS, SaaS, or RaaS — you choose the model",
                "Payments, auth, and analytics wired from day one",
                "Keep full ownership on external builds",
              ].map((b) => (
                <li key={b} className="flex gap-3 text-zinc-300">
                  <Check className="w-5 h-5 text-tib-mint shrink-0 mt-0.5" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="card-edge p-8">
            <Overline className="mb-6">Build request</Overline>
            <LeadForm inquiryType="build-request" />
          </div>
        </div>
      </section>
    </div>
  );
}
